/**
 * Shared project color palette — single source of truth is config/projectColors.json.
 * Used by the project color picker, new-project modal, and takeoff group color picker.
 *
 * Colors are deliberately shuffled so neighbours are visually distinct.
 */
import projectColors from "config/projectColors.json";

export const PROJECT_COLORS: string[] = projectColors;

/** @deprecated Use PROJECT_COLORS instead */
export const ESTIMATOR_PALETTE = PROJECT_COLORS;
